export const blockIconsCommunicationContactSupportNew = (
	<span className='material-symbols-outlined'>contact_support</span>
);
